import React from "react";
import Moment from "moment-timezone";
import translate from "../../../i18n/translate";
import "./ProductCard.scss";

const ProductTemplate = (props: any) => {
  return (
    <div className="parent-active-course">
      <div className="active-course">
        { props.subSkill && props.sprint && (
          <div className="active-course-current-level">
            <b>{translate("currentskills")}</b>
            <label className="active-course-label">{props.subSkill || ""}</label>
          </div>
        )}
        { props.courseDetails.Level  && (
          <div className="active-course-current-level">
            <b>{translate("courselevel")}</b>
            <label className="active-course-label">{props.courseDetails.Level || ""}</label>
          </div>)
        }
        { props.courseDetails.CourseStatus && (
          <div className="active-course-status">
            <b>{translate("SessionRating_status")}</b>
            <label className="active-course-lbl">{props.activeCourseStatus[props.courseDetails.CourseStatus] || ""}</label>
          </div>)
        }
      </div>
      {props.upComingSession && props.courseDetails["UpComingSession"] ? (
        <div className="active-course-block">
          { (props.subSkill || props.subSkillTitle) && (
            <div className="active-course-current-level">
              <b>{translate(props.sprint ? "currentsubskills" : "currentunit")}</b>
              <label className="active-course-label-subskill">{props.sprint ? props.subSkillTitle : props.subSkill}</label>
            </div>)
          }
          {props.courseDetails.UpComingSession.Session.StartTime !== undefined ? (
            <div className="active-course-session">
              <b>{translate("upcomingsession")}</b>
              <label className="active-course-label-session">{Moment.unix(props.courseDetails.UpComingSession.Session.StartTime).format("DD MMM YYYY | hh:mm A ") + Moment.unix(props.courseDetails.UpComingSession.Session.StartTime).tz(Moment.tz.guess()).format("z")}</label>
            </div>
          ) : (
              <div className="active-course-session">
                <b>{translate("upcomingsession")}</b>
                {
                  props.courseDetails.UpComingSession.Session === "Not Scheduled"  && (
                    <label className="active-course-label">{props.courseDetails.UpComingSession.Session}</label>
                  )}
                {
                  props.courseDetails.UpComingSession.Session === "No Sessions" && (
                    <a className="active-course-schedule-label" onKeyDown={() => {}} onClick={(e: any) => props.redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                  )}
              </div>
            )
          }
        </div>
      ) : (
        <div className="active-course-block">
          { props.subSkill && (
            <div className="active-course-current-level">
              <b>{translate(props.sprint ? "currentsubskills" : "currentunit")}</b>
              <label className="active-course-label-subskill">{props.sprint ? props.subSkillTitle : props.subSkill}</label>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ProductTemplate